import { render, staticRenderFns } from "./PlantUpdate.vue?vue&type=template&id=03da8b12&scoped=true"
import script from "./PlantUpdate.vue?vue&type=script&lang=ts"
export * from "./PlantUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03da8b12",
  null
  
)

export default component.exports